<template>
  <Modal
    :title="
      passedDeviceName == undefined
        ? 'Telemetry Search'
        : 'Telemetry Search (' + passedDeviceName + ')'
    "
    :background-primary="true"
    button-icon-pack="fas"
    :button-icon="
      (telemetry.active || graph.active || exportSection.active) &&
        !telemetry.state.isLoading
        ? 'arrow-left'
        : null
    "
    :button-text="
      (telemetry.active || graph.active || exportSection.active) &&
        !telemetry.state.isLoading
        ? 'Back to search'
        : null
    "
    @click="
      telemetry.active = false;
      graph.active = false;
      exportSection.active = false;
    "
    @close="$parent.close()"
  >
    <template #custom-button>
      <download-csv
        v-if="telemetry.active"
        :data="flatDataExport"
        :disabled="(telemetry.isEmpty ? [] : telemetry.results).length == 0"
        name="export.csv"
        style="margin-left: 0.5rem"
        class="button is-dark is-rounded is-small"
      >
        <b-icon
          pack="fas"
          icon="file-csv"
        />
      </download-csv>
    </template>
    <section class="telemetry-section">
      <div
        v-if="UserLoggedIn"
        style="height: auto"
      >
        <form
          v-if="!telemetry.active && !graph.active && !exportSection.active"
          style="text-align: center; display: inline-block"
          action
        >
          <b-field>
            <b-input
              v-model="dataSelector.searchField"
              placeholder="Device EUI..."
              type="search"
              icon="magnify"
              :disabled="!allowCustomEui"
            />
          </b-field>
          <b-field>
            <b-datepicker
              v-model="dataSelector.dates"
              placeholder="Select a date range..."
              icon="calendar-today"
              range
              inline
            />
          </b-field>
          <b-field>
            <b-switch
              v-model="dataSelector.extendedTelemetry"
              type="is-warning"
            >
              Request Metadata
            </b-switch>
          </b-field>
          <div class="field has-addons has-addons-centered">
            <p class="control">
              <a
                class="button is-dark is-rounded"
                :disabled="telemetry.state.isLoading || graph.active"
                @click="
                  telemetry.active = !telemetry.active;
                  request();
                "
              >
                <b-icon
                  pack="fas"
                  icon="table"
                  size="is-small"
                />
                <span>Table</span>
              </a>
            </p>
            <p class="control">
              <a
                class="button is-dark is-rounded"
                :disabled="telemetry.state.isLoading || telemetry.active"
                @click="graph.active = !graph.active"
              >
                <b-icon
                  pack="fas"
                  icon="chart-area"
                  size="is-small"
                />
                <span>Graph</span>
              </a>
            </p>
            <p class="control">
              <a
                class="button is-dark is-rounded"
                :disabled="telemetry.state.isLoading || telemetry.active"
                @click="
                  request(true);
                  exportSection.active = !exportSection.active;
                "
              >
                <b-icon
                  pack="fas"
                  icon="file-csv"
                  size="is-small"
                />
                <span>Export</span>
              </a>
            </p>
          </div>
        </form>
        <div v-if="telemetry.state.hasPrevResults && exportSection.active">
          <b-loading
            :is-full-page="false"
            :active="telemetry.state.isLoading"
            :can-cancel="false"
          />
          <p v-if="passedDeviceName == undefined">
            Your data export is ready.
          </p>
          <p v-else>
            Your data export for {{ passedDeviceName }} is ready.
          </p>
          <p style="margin-bottom: 0.5rem">
            Click the button below to confirm the data export download.
          </p>
          <download-csv
            :data="flatDataExport"
            :disabled="(telemetry.isEmpty ? [] : telemetry.results).length == 0"
            name="export.csv"
            style="margin-bottom: 0.5rem"
            class="button is-info is-rounded"
          >
            <b-icon
              pack="fas"
              icon="check"
            />
            <span>Confirm data export</span>
          </download-csv>
        </div>
        <div v-if="telemetry.state.hasPrevResults && telemetry.active">
          <b-table
            :data="telemetry.isEmpty ? [] : telemetry.results"
            :bordered="false"
            :striped="true"
            :narrowed="true"
            :hoverable="false"
            :loading="telemetry.state.isLoading"
            :focusable="false"
            :mobile-cards="false"
            sort-icon="arrow-up"
            sort-icon-size="is-small"
            default-sort-direction="asc"
            :per-page="15"
            :paginated="true"
          >
            <template slot-scope="props">
              <!--<b-table-column field="id" label="ID">{{ props.row.id }}</b-table-column>-->
              <template v-if="!dataSelector.extendedTelemetry">
                <b-table-column
                  v-for="key in Object.keys(props.row.payload)"
                  :key="key"
                  :field="key"
                  :label="key"
                >
                  {{ props.row.payload[key] }}
                </b-table-column>
              </template>
              <b-table-column
                v-if="dataSelector.extendedTelemetry"
                field="payload_transmission.upstream_hardware_id"
                label="Device EUI"
              >
                {{
                  props.row.payload_transmission.upstream_hardware_id
                }}
              </b-table-column>

              <b-table-column
                v-if="dataSelector.extendedTelemetry"
                field="payload_transmission.upstream_dev_id"
                label="Device ID"
                sortable
              >
                {{
                  props.row.payload_transmission.upstream_dev_id
                }}
              </b-table-column>

              <b-table-column
                v-if="dataSelector.extendedTelemetry"
                field="payload"
                label="Payload"
                centered
              >
                <a
                  @click="
                    activeRowObject = props.row;
                    isPayloadInspectorActive = !isPayloadInspectorActive;
                  "
                ><b-icon
                  pack="fas"
                  icon="external-link-alt"
                /></a>
              </b-table-column>
              <b-table-column
                v-if="dataSelector.extendedTelemetry"
                field="payload_transmission.upstream_metadata.frequency"
                label="Freq."
                centered
                sortable
                numeric
              >
                {{
                  props.row.payload_transmission.upstream_metadata.frequency
                }}
              </b-table-column>

              <b-table-column
                v-if="dataSelector.extendedTelemetry"
                field="payload_transmission.upstream_metadata.coding_rate"
                label="Coding rate"
                centered
                sortable
              >
                {{
                  props.row.payload_transmission.upstream_metadata.coding_rate
                }}
              </b-table-column>

              <b-table-column
                v-if="dataSelector.extendedTelemetry"
                field="payload_transmission.upstream_metadata.data_rate"
                label="Data rate"
                centered
                sortable
              >
                {{
                  props.row.payload_transmission.upstream_metadata.data_rate
                }}
              </b-table-column>

              <b-table-column
                v-if="dataSelector.extendedTelemetry"
                field="payload_transmission.upstream_metadata.gateways"
                label="GW"
                centered
                sortable
                numeric
              >
                <a
                  @click="
                    activeRowObject = props.row;
                    isGatewayInspectorActive = !isGatewayInspectorActive;
                  "
                >{{
                  props.row.payload_transmission.upstream_metadata.gateways
                    .length
                }}</a>
              </b-table-column>

              <b-table-column
                v-if="dataSelector.extendedTelemetry"
                field="payload_transmission.upstream_metadata.time"
                label="Timestamp"
                centered
                sortable
              >
                <span class="tag is-dark">{{
                  new Date(
                    props.row.payload_transmission.upstream_metadata.time
                  ).toLocaleString()
                }}</span>
              </b-table-column>
              <b-table-column
                v-else
                field="date_created"
                label="Timestamp"
                centered
                sortable
              >
                <span class="tag is-dark">{{
                  new Date(props.row.date_created).toLocaleString()
                }}</span>
              </b-table-column>
            </template>
            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>
                    <b-icon
                      icon="emoticon-sad"
                      size="is-large"
                    />
                  </p>
                  <p>No data is available in the selected range.</p>
                </div>
              </section>
            </template>
          </b-table>
        </div>
      </div>
      <div v-if="graph.active">
        <GraphsComponent
          :device-eui="dataSelector.searchField"
          :passed-device-name="passedDeviceName"
          :start-date="dataSelector.dates[0]"
          :end-date="dataSelector.dates[1]"
          :extended-telemetry="dataSelector.extendedTelemetry"
        />
      </div>
      <div
        v-if="!UserLoggedIn"
        class="content has-text-grey has-text-centered"
      >
        <p>
          <b-icon
            icon="emoticon-sad"
            size="is-large"
          />
        </p>
        <p>Please log in to access this page.</p>
      </div>
      <b-modal
        :active.sync="isGatewayInspectorActive"
        :can-cancel="true"
        has-modal-card
      >
        <GatewayInspectorComponent :data="activeRowObject" />
      </b-modal>
      <b-modal
        :active.sync="isPayloadInspectorActive"
        :can-cancel="true"
        has-modal-card
      >
        <PayloadInspectorComponent :data="activeRowObject" />
      </b-modal>
    </section>
  </Modal>
</template>
<script>
import TelemetryApi from "@/services/Telemetry";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import Errors from "@/services/Error";
import Tools from "@/services/Tools";
import GraphsComponent from "@/components/Graphs";
import GatewayInspectorComponent from "@/components/GatewayInspector";
import PayloadInspectorComponent from "@/components/PayloadInspector";
import Modal from "@/components/elements/Modal";

export default {
  name: "TelemetrySearch",
  components: {
    GraphsComponent,
    Modal,
    GatewayInspectorComponent,
    PayloadInspectorComponent,
  },
  props: {
    passedEui: String,
    passedDeviceName: String,
    allowCustomEui: Boolean,
  },
  data() {
    let today = new Date();
    return {
      isGatewayInspectorActive: false,
      isPayloadInspectorActive: false,
      activeRowObject: {},
      dataSelector: {
        dates: [
          new Date(today.getFullYear(), today.getMonth(), today.getDate() - 2),
          new Date(today.getFullYear(), today.getMonth(), today.getDate()),
        ],
        searchField: this.passedEui,
        orderByDate: true,
        extendedTelemetry: true,
      },
      telemetry: {
        active: false,
        isEmpty: false,
        results: [],
        state: {
          isLoading: false,
          hasPrevResults: false,
        },
      },
      graph: {
        active: false,
      },
      exportSection: {
        active: false,
      },
    };
  },
  computed: {
    ...mapState({
      userState: "user",
    }),
    ...mapMutations({
      setUserAuth: "setUserAuth",
    }),
    ...mapGetters(["UserLoggedIn"]),
    flatDataExport: function () {
      let telemetryData = this.telemetry.isEmpty ? [] : this.telemetry.results;
      let csvExport = [];
      telemetryData.forEach((object) => {
        csvExport.push(Tools.flatten(object));
      });
      return csvExport;
    },
  },
  mounted() {
    // this.getUserAuthLocalStorage()
  },
  methods: {
    ...mapActions({
      logout: "clearUserAuth",
      throwGlobalNotification: "throwGlobalNotification",
    }),
    async request(noLimit) {
      this.telemetry.state.isLoading = true;
      this.telemetry.state.hasPrevResults = true;

      var startDate = new Date(this.dataSelector.dates[0]);
      var endDate = new Date(
        this.dataSelector.dates[1].getFullYear(),
        this.dataSelector.dates[1].getMonth(),
        this.dataSelector.dates[1].getDate() + 1
      );

      var limit = noLimit ? 1000000000 : 1000;

      try {
        var results = await TelemetryApi.telemetryRequest(
          this.dataSelector.searchField,
          true,
          limit,
          0,
          startDate.toISOString(),
          endDate.toISOString(),
          this.dataSelector.orderByDate
        );
      } catch (err) {
        this.telemetry.state.isLoading = false;
        if (err.name == Errors.API.Unauthorized.name) {
          this.throwGlobalNotification({
            message: "You have to be logged in to access this data.",
            queue: false,
            isError: true,
          });
        } else if (err.name == Errors.API.UnexpectedErr.name) {
          this.throwGlobalNotification({
            message: "An unexpected error has occurred!",
            queue: false,
            isError: true,
          });
        } else if (err.name == Errors.API.ServerInternalErr.name) {
          this.throwGlobalNotification({
            message: "Internal server error has occurred!",
            queue: false,
            isError: true,
          });
        } else {
          this.throwGlobalNotification({
            message: "Couldn't connect to the API. Are you online?",
            queue: false,
            isError: true,
          });
        }
      }
      if (!results) {
        // do nothing if no results
        this.telemetry.results = [];
        this.telemetry.state.isLoading = false;
      } else {
        for (let i = 0; i < results.length; i++) {
          results[i].payload = JSON.parse(results[i].payload);
        }
        this.telemetry.results = results;
      }
      this.telemetry.state.isLoading = false;
    },
  },
  watch: {},
};
</script>
<style lang="scss">
.telemetry-section {
  padding: 0.25rem 1em 0.5em 1em;
  max-height: 50rem;
  height: auto;
  max-width: 100%;
  width: auto;
  overflow-y: auto;
  overflow-x: auto;
}
</style>
